// extracted by mini-css-extract-plugin
export default {"ResponsiveContainer":"ResponsiveContainer-module__ResponsiveContainer___iJkKa","responsiveContainer":"ResponsiveContainer-module__ResponsiveContainer___iJkKa"};